/**
 * @file _initialize/_accordion.js
 */
(function ($) {
	'use strict';
		var ApplyClass = require('../_util/_apply-class');
		var TabContents = require('../_view/_tabContents');

	/**
	 * recruit formのaccordion 初期化
	 * @return {undefined}
	 */


	var TabContentsInitialize = function () {
		$(function () {
			applyClass();
		});
	};

	/**
	 * Recruit Form の各項目をアコーディオンさせる
	 */
	var applyClass = function (idx, e) {
		$('.index .method-purchase').each(function() {
			var $e = $(e);
			ApplyClass.apply(TabContents, $e);
		});
	};

	module.exports = TabContentsInitialize;
})(jQuery);
